import React from 'react';
import styled from 'styled-components';

const BannerContainer = styled.a`
    background-color: #3cbc41;
    font-weight: 700;
    font-size: 16px;
    text-decoration: none !important;
    color: #f1f1f1;
    font-family: Gilroy;
    transition: all 0.2s ease-in-out;

    @media (min-width: 768px) {
        font-size: 18px;
    }

    &:hover {
        color: #ffffff;
        background-color: rgb(1, 183, 47);
    }

    left: 0;
    top: 0;
    position: sticky;
    width: 100%;
    z-index: 999;
`;

const Banner: React.FC = () => {
    return <></>
    // return (
    //     <BannerContainer
    //         className="bg-elevated d-flex justify-content-center py-2"
    //         href="/blackfriday">
    //         <div className="max-w-sm mx-3">
    //             <small>🎉 Black Friday Sale – upto 50% off!</small>
    //         </div>
    //     </BannerContainer>
    // );
};

export default Banner;
